import React from 'react';
import {style, classes} from './wix-loader.st.css';
import {Values} from '@wix/devzai-utils-common';
import { reactCreateMemo } from "@wix/devzai-utils-react";

export const WixLoaderSize = {
    Tiny: 'tiny',
    Small: 'small',
    Medium: 'medium',
    Large: 'large'
} as const;

export namespace WixLoader {

    export type Size = Values<typeof WixLoaderSize>;

    export interface Props extends React.HTMLAttributes<any> {
        size?: Size;
    }
}

export const WixLoader = reactCreateMemo(function WixLoader (props: WixLoader.Props) {
    const {
        size = WixLoaderSize.Tiny,

        className,
        ...htmlAttributes
    } = props;

    const svgLayerParams = resolveSvgLayerParams(size);

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, className)}
        >
            <div
                className={style(classes.layersContainer, {})}
                style={{
                    width: svgLayerParams.size + 'px',
                    height: svgLayerParams.size + 'px',
                }}
            >
                <LoaderSvg
                    {...svgLayerParams}
                    className={classes.layer1}
                />
                <LoaderSvg
                    {...svgLayerParams}
                    className={classes.layer2}
                />
            </div>
        </div>
    );
});

interface LoaderSvgProps {
    path: string;
    size: number;
    strokeWidth: string;
    className: string;
}

const LoaderSvg = reactCreateMemo(function LoaderSvg (props: LoaderSvgProps) {

    const {
        path,
        size,
        strokeWidth,
        className
    } = props;

    const viewBox = `-${size/2} -${size/2} ${size} ${size}`;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox={viewBox}
            className={className}
        >
            <path
                strokeWidth={strokeWidth}
                d={path}
            />
        </svg>
    );
});

function resolveSvgLayerParams (size: WixLoader.Size) {
    switch (size) {
        case WixLoaderSize.Tiny:
            return {
                size: 18,
                path: 'M 4.408389392193548 6.067627457812106 A 7.5 7.5 0 0 0 4.592425496802575e-16 -7.5',
                strokeWidth: '3'
            };
        case WixLoaderSize.Small:
            return {
                size: 30,
                strokeWidth: '4',
                path: 'M -7.641208279802149 10.517220926874316 A 13 13 0 1 0 7.960204194457795e-16 -13'
            };
        case WixLoaderSize.Medium:
            return {
                size: 54,
                strokeWidth: '4',
                path: 'M 23.776412907378838 7.7254248593736845 A 25 25 0 0 0 1.5308084989341915e-15 -25'
            };
        case 'large':
            return {
                size: 102,
                path: 'M 3.0003846579110155e-15 49 A 49 49 0 0 0 3.0003846579110155e-15 -49',
                strokeWidth: '4'
            };
    }
}
